import emptySliceApi from '../../../../shared/store/emptyApiSlice';
import { CommentItem } from '../../../../shared/models/CommentItem';

export interface AccountCommentsModel {
  currentPage: number;
  pageSize: number;
  pageCount: number;
  totalItemCount: number;
  items: CommentItem[];
}

export interface PostCommentRequest {
  accountId: string;
  dealId: string;
  payload: {
    description: string;
  };
}

export interface UpdateCommentRequest {
  commentId: number;
  payload: {
    description: string;
  };
}

export interface GetCommentsByAccountRequest {
  accountId: string;
  page?: number;
  pageSize?: number;
}

export interface GetCommentsByDealIdRequest {
  accountId: string;
  dealId: string;
  page?: number;
  pageSize?: number;
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getCommentsByAccount: builder.query<
      AccountCommentsModel,
      GetCommentsByAccountRequest
    >({
      query: ({ accountId, page = 1, pageSize = 100 }) =>
        `/comments/account/${accountId}?page=${page}&pageSize=${pageSize}`,
      providesTags: ['CommentItem'],
    }),
    getCommentsByDealId: builder.query<
      AccountCommentsModel,
      GetCommentsByDealIdRequest
    >({
      query: ({ accountId, dealId, page = 1, pageSize = 100 }) =>
        `/comments/account/${accountId}/deal/${dealId}?page=${page}&pageSize=${pageSize}`,
      providesTags: ['CommentItem'],
    }),
    postComment: builder.mutation<void, PostCommentRequest>({
      query: ({ accountId, dealId, payload }) => ({
        url: `/comments/account/${accountId}/deal/${dealId}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['CommentItem'],
    }),
    updateComment: builder.mutation<void, UpdateCommentRequest>({
      query: ({ payload, commentId }) => ({
        url: `/comments/${commentId}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['CommentItem'],
    }),
    deleteComment: builder.mutation<void, { commentId: number }>({
      query: ({ commentId }) => ({
        url: `/comments/${commentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CommentItem'],
    }),
    commentRead: builder.mutation<void, { accountId: string; dealId: string }>({
      query: ({ accountId, dealId }) => ({
        url: `/comments/account/${accountId}/deal/${dealId}/read`,
        method: 'POST',
      }),
      invalidatesTags: ['CommentItem'],
    }),
  }),
});

export const {
  useGetCommentsByAccountQuery,
  useGetCommentsByDealIdQuery,
  usePostCommentMutation,
  useUpdateCommentMutation,
  useDeleteCommentMutation,
  useCommentReadMutation,
} = apiSlice;
